export default {"src":"/_next/static/media/down_caret.a4e1a995.svg","height":24,"width":24};